/*铭记历史*/
import {REMEMBER,urlpostfix,jsonpostfix} from '@/config/global.js'
import {getJSON,post} from '@/config/config.js'

/**/
/*export function getmjlsJsondata(data){
  return getJSON(`/allWzJSON/allWzJSON/${REMEMBER}/${REMEMBER}.json`,);
}
export function getmjlsAjaxdata(data){
  return post('api/basic/getBasicNew',data);
}*/


export function getmjlsJsondata(data){
  return getJSON(`${jsonpostfix}allWzJSON/${REMEMBER}/${REMEMBER}.json`,);
}
export function getmjlsAjaxdata(data){
  return post(`${urlpostfix}api/basic/getBasicNew`,data);
}











// WEBPACK FOOTER //
// ./src/api/rememberhistory.js